module.exports = __webpack_public_path__ + "img/chrome.2f6482cf.png";